import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';
import { Download } from 'react-bootstrap-icons';
import MonitoringListSelect from './FormComponents/MonitoringListSelect';
import ExportFieldsModal, {
  CLIENT_EXPORT_FIELDS,
  ExportField
} from './FormComponents/ExportFieldsModal';

import { customFetch } from '../helpers/customFetch';
import { downloadAsCsv } from '../Functions';

function DownloadClientEmails() {
  const [isLoading, setIsLoading] = useState(false);
  const [monitoringListId, setMonitoringListId] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleExport = (selectedFields: ExportField[]) => {
    setIsLoading(true);

    const params = new URLSearchParams();
    if (monitoringListId) params.append('monitoringListId', monitoringListId);
    if (selectedFields.length > 0) {
      params.append('fields', selectedFields.map((f) => f.value).join(','));
    }

    const endpoint = '/Client/DownloadClients?' + params.toString();
    customFetch<any>({
      endpoint,
      config: {
        headers: {
          'Content-Type': 'text/csv;charset=UTF-8'
        }
      },
      skipParseBody: true,
      callback: async (res) => {
        downloadAsCsv(await res.text(), `Client Export ${new Date().toLocaleString()}`);
        setIsLoading(false);
        setShowModal(false);
      }
    });
  };

  return (
    <>
      <Form style={{ marginBottom: 15 }}>
        <Stack direction="vertical" gap={2}>
          <Form.Text style={{ whiteSpace: 'pre-wrap' }}>
            Download a spreadsheet of all clients
          </Form.Text>
          <Stack direction="horizontal" gap={3}>
            {showFilter && (
              <MonitoringListSelect
                value={monitoringListId}
                addNew={false}
                showAllOption={true}
                handleDataChange={(_, value) => setMonitoringListId(value)}
              />
            )}
            <Button
              className="ms-auto"
              style={{ whiteSpace: 'nowrap' }}
              variant={showFilter ? 'secondary' : 'primary'}
              onClick={() => {
                if (showFilter) {
                  setMonitoringListId('');
                }
                setShowFilter(!showFilter);
              }}>
              {showFilter ? 'Clear Filter' : 'Add Filter'}
            </Button>
            <Button variant="primary" onClick={() => setShowModal(true)}>
              <Download size={20} />
            </Button>
          </Stack>
        </Stack>
      </Form>

      <ExportFieldsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onExport={handleExport}
        availableFields={CLIENT_EXPORT_FIELDS}
        title="Export Client Data"
        isLoading={isLoading}
      />
    </>
  );
}

export default DownloadClientEmails;
